/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_Twittertitle1Inputs */

const ja_home_meta_twittertitle1 = /** @type {(inputs: Home_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN（株式会社プレイブレーン） | ゲームマーケティング・eスポーツ制作会社`)
};

const en_home_meta_twittertitle1 = /** @type {(inputs: Home_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Japanese Marketing for Games and Production for Esports`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Japanese Marketing for Games and Production for Esports" |
*
* @param {Home_Meta_Twittertitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_meta_twittertitle1 = /** @type {((inputs?: Home_Meta_Twittertitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_Twittertitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_meta_twittertitle1(inputs)
	return en_home_meta_twittertitle1(inputs)
});
export { home_meta_twittertitle1 as "home_meta_twitterTitle" }